// src/ui/MemoriesStrip.jsx — "On this day" on your own profile (the phone's MemoriesCard).
// One small query per year back, on your own posts, once a day per tab
// (services/memories says which days and how to group them).
import React, { useEffect, useState } from 'react';
import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';
import { memoryWindows, onThisDay } from '../services/memories';
import { gridThumb } from '../services/postGrid';
import SafeImg from './SafeImg';

const cache = new Map();

export default function MemoriesStrip({ uid, onOpen }) {
  const today = new Date().toDateString();
  const hit = cache.get(uid);
  const [groups, setGroups] = useState(hit && hit.day === today ? hit.groups : []);
  useEffect(() => {
    if (!uid || (hit && hit.day === today)) return undefined;
    let live = true;
    const now = Date.now();
    Promise.all(memoryWindows(now).map((w) => getDocs(query(collection(db, 'posts'),
      where('userId', '==', uid), where('timestamp', '>=', new Date(w.from)), where('timestamp', '<', new Date(w.to)),
      orderBy('timestamp', 'desc'), limit(10))).catch(() => null)))
      .then((snaps) => {
        const all = [];
        snaps.forEach((s) => { if (s) s.docs.forEach((d) => { const x = d.data() || {}; if (x.authorType !== 'page') all.push({ id: d.id, ...x }); }); });
        const g = onThisDay(all, now);
        cache.set(uid, { day: today, groups: g });
        if (live) setGroups(g);
      });
    return () => { live = false; };
  }, [uid]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!groups.length) return null;
  return (
    <div className="vb-mem">
      <b>🕰 On this day</b>
      {groups.map((g) => (
        <div key={g.years}>
          <div className="vb-mem-year">{g.years === 1 ? '1 year ago' : `${g.years} years ago`}</div>
          <div className="vb-mem-row">
            {g.posts.map((p) => {
              const th = gridThumb(p);
              return (
                <button key={p.id} className="vb-mem-tile" onClick={() => onOpen && onOpen(p)}>
                  {th && th.uri ? <SafeImg src={th.uri} kind="inline" loading="lazy" /> : <span>{(p.content || p.pollQuestion || '').slice(0, 80)}</span>}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
